import { render, staticRenderFns } from "./GoBackBtn.vue?vue&type=template&id=1ceccacc"
import script from "./GoBackBtn.vue?vue&type=script&lang=js"
export * from "./GoBackBtn.vue?vue&type=script&lang=js"
import style0 from "./GoBackBtn.vue?vue&type=style&index=0&id=1ceccacc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports